import { ConfigurationService } from './configuration.service';

export const configurationAppInitializerFn = (configService: ConfigurationService) => {
    return () => {
        if (!configService.isLoaded) {
            throw new Error('[CONFIG INIT] The config object is empty - not loaded correctly');
        }
    };
};
